import { Decimal } from "decimal.js";

// Service fee = reimbursement * percentage + fixed fee, always rounded up to the cent.
export function computeServiceFee(
  reimbursement,
  percentageOfProduct = 0,
  fixedFee = 0
) {
  return new Decimal(reimbursement)
    .mul(percentageOfProduct / 100)
    .add(fixedFee || 0)
    .mul(100)
    .ceil()
    .div(100)
    .toFixed(2);
}

// Total price the brand pays: reimbursement + service fees, to the cent.
export function computeTotalPrice(reimbursement, serviceFees = 0) {
  return new Decimal(reimbursement).add(serviceFees || 0).toFixed(2);
}

// Human-readable breakdown of the calculated service fee (tax % + shipping fee).
export function buildServiceFeeDescription(
  percentageOfProduct = 0,
  fixedFee = 0
) {
  const parts = [];
  if (percentageOfProduct > 0) {
    parts.push(`${percentageOfProduct}% Average tax rate`);
  }
  if (fixedFee > 0) {
    parts.push(`$${Number(fixedFee).toFixed(2)} shipping fee`);
  }
  return parts.join(" + ");
}
